export default __webpack_public_path__ + "static/media/error404.8c297398.svg";